module.exports = __webpack_public_path__ + "img/logo.ca610ae2.png";